<div class="nbt-wrapper" *ngIf="isLoading || hasData">
    <h2 class="nbt-title">Next Best Trade Recommendations</h2>

    <div *ngIf="isLoading" class="nbt-loading">
        <mat-spinner diameter="32"></mat-spinner>
    </div>

    <div *ngIf="!isLoading && hasData" class="nbt-cards">
        <div class="nbt-card" *ngFor="let step of steps">
            <div class="nbt-card-header">{{ step.label }}</div>
            <div class="nbt-card-body">
                <p class="nbt-desc">
                    {{ getStep(step.key)?.description ?? 'No meaningful trade available.' }}
                </p>
                <span class="nbt-badge" [class.nbt-badge--empty]="!getStep(step.key)">
                    {{ getStep(step.key) ? formatCloseness(getStep(step.key)!.closeness) : '0%' }} closer
                </span>
            </div>
        </div>
    </div>
</div>
